import * as React from 'react';

import { cn } from '../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Apply notched corners */
  notched?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, notched = true, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full px-3 py-2 text-sm text-white transition-all',
          'placeholder:text-gray-500',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          notched
            ? // Notched: use pseudo-element border that follows clip-path
              'notch-border-sm notch-border-white/8 notch-bg-white/3 notch-border-hover notch-bg-hover notch-border-focus notch-bg-focus focus:outline-none'
            : // Rounded: use regular CSS border
              'rounded-lg border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.05] hover:border-white/[0.12] focus:border-brand-400 focus:bg-white/[0.05] focus:outline-none focus:ring-1 focus:ring-brand-400',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
